import React from "react";
import usePageTitle from "../hooks/usePageTitle";
import { useTranslation } from "react-i18next";
import "./LegalPage.css";

function GuidelinesPage() {
  const { t } = useTranslation();
  usePageTitle(t("guidelines.pageTitle"));

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <span className="last-updated">{t("guidelines.lastUpdated")}</span>
          <h1 className="legal-title">{t("guidelines.heroTitle")}</h1>
          <p className="legal-subtitle">{t("guidelines.heroSubtitle")}</p>
        </div>
      </div>

      <div className="container">
        <div className="legal-content">
          <section className="legal-section">
            <h2>{t("guidelines.s1Title")}</h2>
            <p>{t("guidelines.s1Content")}</p>
            <ul>
              <li>{t("guidelines.s1Item1")}</li>
              <li>{t("guidelines.s1Item2")}</li>
              <li>{t("guidelines.s1Item3")}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t("guidelines.s2Title")}</h2>
            <p>{t("guidelines.s2Content")}</p>
            <ul>
              <li>{t("guidelines.s2Item1")}</li>
              <li>{t("guidelines.s2Item2")}</li>
              <li>{t("guidelines.s2Item3")}</li>
              <li>{t("guidelines.s2Item4")}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t("guidelines.s3Title")}</h2>
            <p>{t("guidelines.s3Content")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("guidelines.s4Title")}</h2>
            <p>{t("guidelines.s4Content")}</p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default GuidelinesPage;
